
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'free-subscriptions-pick-member-dialog',
    emits: ['newMember', 'searchForMember']
})
